import { useState } from "react"
import { TFilters } from "../../../../../components/TableDataGridV2/types"
import {
    Box,
    Button,
    Grid,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Typography
} from "@mui/material"
import { permitirApenasNumeros } from "../../../../../helpers/masks"
import SelectPublico from "../../../../../components/SelectsSimpleApiQuery/SelectPublico"
import CloseIcon from '@mui/icons-material/Close';
import { TPreFilters } from "../ListarTodos/Listagem"

export default function DialogFiltrosPublico({
    filtrosAtuais,
    tipoPublico,
    onConfirm,
    open,
    onClose
}: PreFiltrosProps) {

    const [internFilters, setInternFilters] = useState(filtrosAtuais)

    const filtrarObj = (obj: TFilters) => {
        const novoObjeto: TFilters = { ...obj };

        Object.keys(novoObjeto).forEach((key) => {
            if (key.startsWith('publico_dado')) {
                novoObjeto.codigo_publico_contem = [novoObjeto[key].codigo_publico];
                delete novoObjeto[key];
            }
        });

        return novoObjeto;
    };

    const handleInsertFiltros = (prop: string, value: any) => {
        setInternFilters(prevState => ({ ...prevState, [prop]: value }))
    }

    const handleSubmit = () => {
        const formatValue = filtrarObj(internFilters)
        onConfirm(formatValue)
    }

    const clearFilters = () => {
        const emptyFilters = {};
        setInternFilters(emptyFilters);
        onConfirm(filtrarObj(emptyFilters));
        onClose();
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6">Filtrar Públicos</Typography>
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Box py={2}>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <SelectPublico
                                defaultFiltroTipoClient={tipoPublico}
                                value={internFilters.publico_dado}
                                onChange={(valor) => handleInsertFiltros("publico_dado", valor)}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <TextField
                                label="Nome"
                                variant="outlined"
                                fullWidth
                                value={internFilters.nome_pessoa_pesquisar || ''}
                                onChange={(e) => handleInsertFiltros("nome_pessoa_pesquisar", e.target.value)}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <TextField
                                label="Documento"
                                variant="outlined"
                                fullWidth
                                value={internFilters.documento_pessoa_pesquisar || ''}
                                onChange={(e) => {
                                    handleInsertFiltros("documento_pessoa_pesquisar", permitirApenasNumeros(e.target.value))
                                }}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <TextField
                                label="E-mail"
                                variant="outlined"
                                fullWidth
                                value={internFilters.email_pesquisar || ''}
                                onChange={(e) => handleInsertFiltros("email_pesquisar", e.target.value)}
                            />
                        </Grid>
                    </Grid>
                </Box>
            </DialogContent>
            <DialogActions sx={{ p: 2, pt: 0 }}>
                <Button onClick={clearFilters} variant="outlined"
                    color="primary">
                    Limpar
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        handleSubmit();
                        onClose();
                    }}
                >
                    Aplicar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

interface PreFiltrosProps {
    filtrosAtuais: TPreFilters,
    onConfirm: (filters: TPreFilters) => void,
    tipoPublico: string[],
    open: boolean,
    onClose: () => void
}